import moment from 'moment';
import { CgArrowRight } from "react-icons/cg";
import Cookies from 'universal-cookie';
import { FaTimes, FaUser } from 'react-icons/fa';

export const getCookie = (cookiename = "token", parseJson = false) => {
    // Get name followed by anything except a semicolon
    var cookiestring = RegExp(cookiename + "=[^;]+").exec(document.cookie);
    // Return everything after the equal sign, or an empty string if the cookie name not found
    cookiestring = decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
    if (parseJson && cookiestring) {
        cookiestring = JSON.parse(cookiestring);
    }
    return cookiestring || "";
}

export const setCookie = (value, cookiename = "token") => {
    const cookies = new Cookies();
    cookies.set(cookiename, value, {
        path: "/",
        secure: true,
        expires: 0,
        sameSite: 'Strict'
    });
}

export const deleteCookie = (cookiename = "token") => {
    const cookies = new Cookies();
    cookies.remove(cookiename, {
        path: "/",
        secure: true,
        sameSite: 'Strict'
    });
}

export const userIcon = (user, online = true) => {
    const initials = (user.firstName.trim()[0] + user.lastName.trim()[0]).toUpperCase();
    const char = Math.floor((initials.charCodeAt(0) - 65) / 2);
    const colors = [
        ["#F7FFE5", "#A0C49D"], ["#F9F5F6", "#E8A0BF"], ["#E3F4F4", "#116A7B"], ["#EEEEEE", "#537188"], ["#FDF4F5", "#E8A0BF"], ["#FEFAE0", "#A4BC92"],
        ["#FEFCF3", "#DBA39A"], ["#F8EDE3", "#85586F"], ["#FFE3E1", "#E97777"], ["#CDF0EA", "#54BAB9"], ["#FFFDDE", "#BF8B67"], ["#E4EFE7", "#064420"], ["#CFDAC8", "#7C9473"]
    ];
    const color = colors[char] || colors[0];
    return (
        <div className='relative inline-flex items-center justify-center h-10 font-semibold text-base w-10' style={{ backgroundColor: color[0], color: color[1], borderRadius: '50%' }}>
            {initials}
            {online === true && <>{onlineCircle(user)}</>}
        </div>
    )
}

const onlineStatus = (user) => {
    let status = "offline";
    const current = moment().subtract(3, 'minutes');
    const last = user.lastActiveTime ? moment.utc(user.lastActiveTime).local() : false;
    if (last !== false) {
        if (last.isSameOrAfter(current)) {
            status = "online"
        }
        else {
            const mins = moment().diff(last, 'minutes');
            if (mins < 20) {
                status = "away";
            }
        }
    }
    return status;
}

export const onlineBar = (user) => {
    const colors = {
        "online": "#10cc00",
        "offline": "transparent",
        "away": "#ff972c"
    }
    const status = onlineStatus(user);
    return (
        <div className='absolute left-0 bottom-0 h-1 w-full' style={{ backgroundColor: colors[status] }}></div>
    )
}

export const onlineCircle = (user) => {
    const colors = {
        "online": "#10cc00",
        "offline": "#999",
        "away": "#ff972c"
    }
    const status = onlineStatus(user);
    return (
        <>
            {
                status !== "offline" && (
                    <div className='absolute bottom-0 right-0 w-full h-full border-2' style={{ borderColor: colors[status], borderRadius: '50%' }}></div>
                )
            }
            <div className='absolute bottom-0 right-0 inline-flex text-xs items-center justify-center h-4 w-4' style={{ backgroundColor: colors[status], color: 'white', borderRadius: '50%', marginRight: '-3px', padding: '4px' }}>
                {status === "away" && <CgArrowRight />}
                {status === "online" && <FaUser />}
                {status === "offline" && <FaTimes />}
            </div>
        </>
    )
}